import React from 'react';

import ComponentCounter from '../chart/ComponentCounter';

const CriteriaComponentCount = props => {
    let prevalidatedCount;
    if (props.checkin.prevalidated) {
        prevalidatedCount = <span>P: {props.checkin.prevalidated} </span>;
    } else {
        prevalidatedCount = '';
    }

    const org = props.org;
    const checkinNumber = props.checkinNumber;
    let componentCount = org ? org.components[checkinNumber].count : 0;
    if (!Number.isInteger(componentCount)) {
        componentCount = Math.ceil(componentCount.toFixed(2));
    }
    const coreCount = org ? org.core[checkinNumber].planned : 0;
    const electiveCount = org ? org.elective[checkinNumber].planned : 0;

    return (
        <div className="CriteriaComponentCount">
            <div className="CriteriaComponentCount-bar">
                <ComponentCounter target={props.checkin} current={componentCount} />
            </div>
            <div className="CriteriaComponentCount-label">
                <div className="current">
                    <span className="number">{componentCount}</span>
                    <span className="label">Components</span>
                    <div className="breakdown">
                        C: {coreCount}&nbsp; E: {electiveCount}&nbsp;
                        {prevalidatedCount}
                    </div>
                </div>
                <div className="info">
                    <span className="name">{props.name}</span>
                    <span className="target">
                        Target: {props.checkin.min}-{props.checkin.max} Components
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CriteriaComponentCount;
